import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div(
  props => `
    padding: 28px;
    .wrapper  {
        display: flex;
        background-color: #fff;
        border-radius: 0.8rem;
        flex-direction: column;
        padding: 3rem;
    }

    .heading {
        font-size: 20px;
        color: rgb(0, 0, 0);
        font-weight: 900;
        margin-bottom: 19px;
    }


    .formSubmitSection { 
        width: 100%;
        display: flex;
        margin-top: 45px;
        border-top: 1px solid rgb(231, 231, 231);
        padding: 1.5rem 1.5rem 0px;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: end;
        justify-content: flex-end;
    }

    .cancelButton {
        width: 10rem;
        height: 4rem;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        border-radius: 0.4rem;
        outline: none;
        border: none;
        color: rgb(255, 255, 255);
        background-color: rgb(74, 74, 74);
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
    }

    .submitButton {
        width: 10rem;
        height: 4rem;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        border-radius: 0.4rem;
        outline: none;
        border: none;
        color: rgb(255, 255, 255);
        background-color: rgb(0, 140, 255);
        margin-left: 2rem;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
        opacity: 1;

    }

    .submitButton:disabled {
      /* Add your styles here. For example: */
      background-color: #cccccc;
      color: #666666;
      cursor: not-allowed;
      opacity: 0.5;
    }


    .rightAlignButton { 
        float: right;
        display: inline-block;
        margin-top: 12px;
        font-size: 1.4rem;
        color: rgb(0, 140, 255);
        font-weight: bold;
        cursor: pointer;
        border: none;
        background: no-repeat;
        margin-left: 10px;
    }
`,
);

export const EmailVerifyPopWrap = styled.div(
  props => `
        width:100%;
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,0.4);
        z-index:9;
    `,
);

export const EmailVerifyPopContentWrap = styled.div(
  props => `
        width: 60rem;
        display: flex;
        background-color: #fff;
        border-radius: 0.8rem;
        flex-direction: column;
        padding: 3rem;
    `,
);

export const EmailVerifyPopHeadWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-bottom: 1rem;
        justify-content: flex-end;
    `,
);

export const PopBackBtn = styled.a(
  props => `
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
    `,
);

export const EmailVerifyBodyWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-top:0.5rem;
        flex-direction: column;
    `,
);

export const VerifyForm = styled.form(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    `,
);

export const EmailVerifyBodyHeadWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);

export const EmailVerifyMainText = styled.h2(
  props => `
        font-size: 2.8rem;
        color: #000000;
        font-weight: 900;
    `,
);

export const EmailVerifyInfoWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
    `,
);

export const EmailVerifyInfoText = styled.p(
  props => `
        font-size: 1.5rem;
        color:#000000;
    `,
);

export const EmailVerifyEditBtn = styled.a(
  props => `
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
        margin-left:2rem;
    `,
);

export const OptBlockWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin: 3rem 0; 
        flex-direction: column;
    `,
);

export const ErrorText = styled.span(
  props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.large.font14};
          padding-bottom: ${props.theme.spacing.base};
          text-align: ${props.theme.font.textAlign.left};
          width: 100%;
    `,
);

export const VerifyInfoText = styled.p(
  props => `
        font-size:1.2rem;
        color:rgba(0,0,0,0.8);
        padding-top: 1rem;
        
    `,
);

export const OtpFooterBtnWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        border-top: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l15} 0; 
        align-items: center;
        justify-content: flex-end;
    `,
);

export const CancelBtn = styled.button(
  props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.grey.base};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `,
);

export const SubmitBtn = styled.button(
  props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.blue.base};
        margin-left: ${props.theme.spacing.large.l20};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
    `,
);

export const InputWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin: 1.5rem 0;
    `,
);

export const CommonInput = styled.input(
  props => `
    width: 100%;
    height: 4.2rem;
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font16};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    position: relative;
    cursor: pointer;
    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.lightc5};
      overflow: visible;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props.theme.font.large.font14};
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
    text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
`,
);

export const TextInputContainer = styled.div`
  .textInputBox {
    width: 100%;
    height: 4.2rem;
    border: 1px solid rgb(208, 208, 208);
    background-color: rgb(255, 255, 255);
    border-radius: 0.2rem;
    font-size: 1.6rem;
    padding: 1rem 1.5rem;
    color: rgb(74, 74, 74);
    font-weight: bold;
    position: relative;
    cursor: pointer;
    opacity: 1;
  }
  .inputLabel {
    font-size: 16px;
    color: #4a4a4a;
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;

export const InputCont = styled.div`
  display: flex;
  align-items: center;
  > div > div {
    margin-right: 20px;
  }
  input {
    width: 60px !important;
    height: 60px !important;
    border: 1px #d0d0d0 solid;
    border-radius: 2px;
    outline: 0;
    font-family: 'Lato';
    font-size: 20px;
    line-height: 24px;
    color: #4a4a4a;
    font-weight: 700;
  }
  @media ${device.mobileS} {
    > div > div {
      margin-right: 8px;
    }
    input {
      width: 35px !important;
      height: 35px !important;
      font-size: 16px;
      line-height: 18px;
    }
  }
`;
